import React, { FunctionComponent, useState, useEffect, Fragment } from 'react';
import { Row, Tooltip } from 'react-bootstrap';
import ConsumptionCard from './ConsumptionCard';
import ObexRequestHandler from '../../../handlers/ObexRequestsHandler';
import AddProjectModalSel from '../../Modals/addProjectModalSelect';
import AddProjectModal from '../../Modals/addProjectModal';
import AddTxSelModal from '../../Modals/addTxModalSelect';
import AddStorageModal from '../../Modals/addStorageModal';
import AddBalanceModalSelection from '../../Modals/addBalanceModalSelection';
import AddIncomeModalSelection from '../../Modals/addIncomeModalSelection';
import { amountToEur, parseToNumberFormat } from '../../../services/AmountService';
import UpgradePlanModal from '../../Modals/UpgradePlanModal';
import AddDeveloperModalSel from '../../Modals/addDevelopersModalSelect';
import AddDeveloperModal from '../../Modals/addDeveloperModal';


const Consumptions:FunctionComponent<{}> = () => {

    const [slotsInfo, setSlots] = useState({
        allowProjectsBySubscription: 0,
        maxAllowProjecs: 0,
        maxExtraProjects: 0,
        extraPurchasedProjects: 0,
        activeProjects: 0,
        totalSlots: 0,
        availableSlots: 0,
        activeUsers : 0,
        maxAllowUsers: 0
    });
    const [txInfo, setTx] = useState({  
      limit: 0,
      current: 0,
      rest: 0,
      projects: {}
    });
    const [possibleProjectsToBuy, setPossibleProjectsToBuy] = useState(0);
    const [possibleDevelopersToBuy, setPossibleDevelopersToBuy] = useState(0);
    const [possibleSlotsToBuy, setSlotsToBuy] = useState(0);
    const [addingProjects, setAddingProjects] = useState(false);

    const [addingDevelopers, setAddingDevelopers] = useState(false);

    const [addingTx, setAddingTx] = useState(false);
    const [addingBalance, setAddingBalance] = useState(false);
    const [removingIncome, setRemovingIncome] = useState(false);
    const [balance, setBalance] = useState('€0,00');
    const [income, setIncome] = useState('€0,00');
    const [loadingProject, setLoadingProject] = useState(true);
    const [loadingTx, setLoadingTx] = useState(true);
    const [loadingBalance, setLoadingBalance] = useState(true);
    const [loadingIncome, setLoadingIncome] = useState(true);
    const [availableAdd, setAvailableAdd] = useState(false);
    const [loadingStorage, setLoadingStorage] = useState(true);
    const [addingStorage, setAddingStorage] = useState(false);
    const [storageUsed, setStorageUsed] = useState('-');
    const [storageLimit, setStorageLimit] = useState('-');
    const [storageHelper, setStorageHelper] = useState(false);
    const [currentSuscription, SetCurrentsuscripcion] = useState(0);
    const [maxTX, setMaxTX] = useState(3100);
    const [actualTX, setActualTX] = useState(0)
    const [MaxDBSize, setMaxDBSize] = useState(0);
    const [ActualDBSize, setActualDBSize] = useState(0);
    const [UsedMembers, setUsedMembers] = useState(0);
    const [MaxMembers, setMaxMembers] = useState(0);
    const [DeveloperMultiplier, setDeveloperMultiplier] = useState(0);


    const handleAddProjects = () => {
      const restOfPossibleProjectToBuy = slotsInfo.maxExtraProjects - slotsInfo.extraPurchasedProjects;
      setPossibleProjectsToBuy(restOfPossibleProjectToBuy);
      setAddingProjects(!addingProjects);
    }

    const handleAddDevelopers = () => {
      const restOfPossibleDevelopersToBuy = MaxMembers - UsedMembers;
      setPossibleDevelopersToBuy(restOfPossibleDevelopersToBuy);
      setAddingDevelopers(!addingDevelopers);
    }


    const handleAddTx = () => setAddingTx(!addingTx);
    const handleAddStorage = () => setAddingStorage(!addingStorage);
    const handleAddBalance = () => setAddingBalance(!addingBalance);
    const handleRemoveIcome = () => setRemovingIncome(!removingIncome);
    

    const projectsCard = <ConsumptionCard title='Projects' plus={true} value={`${slotsInfo.activeProjects}/${slotsInfo.maxAllowProjecs}`} action={handleAddProjects} loading={loadingProject} available={availableAdd} info={false} currentSuscription={currentSuscription}/>
    const usersCard = <ConsumptionCard title='Developers' plus={true} value={`${UsedMembers}/${MaxMembers}`} action={handleAddDevelopers} loading={loadingProject} available={availableAdd} info={false} currentSuscription={currentSuscription}/>
    const txCard =  <ConsumptionCard title='Requests' plus={true} value={`${txInfo.current}/${txInfo.limit}`} action={handleAddTx} loading={loadingTx} available={true} info={false} currentSuscription={currentSuscription}/>
    const balanceCard =  <ConsumptionCard title='Balance' plus={true} value={balance} action={handleAddBalance} loading={loadingBalance} available={true} info={false} currentSuscription={currentSuscription}/>
    const storageCard =  <ConsumptionCard title='Storage' plus={true} value={`${storageUsed}/${storageLimit} MB`} action={handleAddStorage} loading={loadingStorage} available={true} info={storageHelper} currentSuscription={currentSuscription}>
        i
    </ConsumptionCard>

    const incomeCard =  <ConsumptionCard title='Income' plus={false} value={income} action={handleRemoveIcome} loading={loadingIncome} available={true} info={false} currentSuscription={currentSuscription}/>

    const getConsumption = async (disableCache: boolean = false) => {
        const result = await ObexRequestHandler.get('/consumption', {}, disableCache);
        const { success, data } = result;
        if (success) {
          setMaxTX(data.subscriptionInfo.max_month_rate_limit)
          setLoadingTx(false);
          setLoadingProject(false);
          const { slots, tx } = data;
          setActualTX(tx.limit);
          tx.limit = new Intl.NumberFormat('en-Us').format(tx.limit);
          tx.current = new Intl.NumberFormat('en-US').format(tx.current);
          setSlots(slots);
          setSlotsToBuy(slots.maxExtraProjects - slots.extraPurchasedProjects);

          //console.log(`RESULTADO DE CONSUMO ${slots.maxExtraProjects - slots.extraPurchasedProjects}`)

          setTx(tx);
        }
    }

    const getBalance = async (disableCache: boolean = false) => {
      setLoadingBalance(true);
      try {
        const result = await ObexRequestHandler.get('/balance', {}, disableCache);
        const { success, data, message } = result;
        if (!success)  throw { message };
        const balance = amountToEur(data);
        setBalance(balance);
      } catch (error) {
        console.error('ERROR FETCHING BALANCE ', error)
      }
      setLoadingBalance(false);
    }

    const getIncome = async (disableCache: boolean = false) => {
      setLoadingIncome(true);
      try {
        const result = await ObexRequestHandler.get('/income', {}, disableCache);
        const { success, data, message } = result;
        if (!success) throw { message };
        const income = amountToEur(data);
        setIncome(income);
      } catch (error) {
        console.error('ERROR FETCHING INCOME ', error)
      }
      setLoadingIncome(false);
    }

    const getStorage = async (disableCache: boolean = false) => {
      setLoadingStorage(true);
      setStorageHelper(false);
      try {
        const result = await ObexRequestHandler.get('/database_usage', {}, disableCache);
        const { success, data, message } = result;

        setActualDBSize(data.allowed.total.db_size_project);
        setMaxDBSize(data.allowed.total.db_size_total);
        if (!success) throw { message };
        //const storageUsed = (data.used.total / 1e+6).toFixed(2).toString();
        //const storageLimit = (data.allowed.total.db_size_total  / 1e+6).toFixed(2).toString();

        const storageUsed = new Intl.NumberFormat('en-US').format(Math.trunc(data.used.total / 1e+6));
        const storageLimit = new Intl.NumberFormat('en-US').format(Math.trunc((data.allowed.subscription.db_size_project+ data.allowed.bought.extra_total_size ) / 1e+6));

        setStorageUsed(storageUsed);
        setStorageHelper(false);
        setStorageLimit(storageLimit);
      } catch (error) {
        console.error('ERROR FETCHING STORAGE ', error)
        setStorageHelper(true);
      }
      setLoadingStorage(false);
    }

    const getSusbscription = async (disableCache: boolean = false) => {
      setLoadingStorage(true);

      try {
        const result = await ObexRequestHandler.get('/current_subscription', {}, disableCache);

        setMaxDBSize(result.data.db_size_total);
        const { success, data, message } = result;
        if (!success) throw { message };
        const currentsuscripcion = (data.subscription_id);
        const max_members_allow = (data.max_members_slots);
        const active_slots_members = (data.active_slots_members);

        const annualPayment = (data.annual_payment);
        const annualprice = (data.annual_price)
        const monthlyprice = (data.monthly_price)

        SetCurrentsuscripcion(currentsuscripcion);
        setMaxMembers(max_members_allow);
        setUsedMembers(active_slots_members);

        setDeveloperMultiplier(annualPayment ? annualprice : monthlyprice);

        //console.log("SUSCRIPTION DATA")
        //console.log(data);

      } catch (error) {
        console.error('ERROR FETCHING STORAGE ', error)

      }
      setLoadingStorage(false);
    }

    const getData = (disableCache:boolean = false) => {
      getConsumption(disableCache);
      getIncome(disableCache);
      getBalance(disableCache);
      getStorage(disableCache);
      getSusbscription(disableCache);
    }

    useEffect(() => {
        getData();
        const consumptionInterval = setInterval(getData, 1000000); // Cada 30seg
        return () => { 
          clearInterval(consumptionInterval) // El return en el use effect ejectuta la función dada cuando el componente se desmonta
        }
    }, []);

    useEffect(() => {
      if(slotsInfo.activeProjects < slotsInfo.maxAllowProjecs){
        setAvailableAdd(true);
      }else{
        setAvailableAdd(false);
      }
    }, [slotsInfo])

    // Método para cuando se cierra un modal(no obtenemos los datos si no se opera)
    const whenClosing = () => {
      setAddingTx(false);
      setAddingBalance(false);
      setAddingProjects(false);

      setAddingDevelopers(false);

      setRemovingIncome(false);
      setAddingStorage(false);
      //getData();
    }
    
    // Método para cuando una operación de un modal ha ido bien y obtiene los datos de nuevo sin cachear
    const onSuccess = () => {
      setAddingTx(false);
      setAddingBalance(false);
      setAddingProjects(false);

      setAddingDevelopers(false);

      setRemovingIncome(false);
      setAddingStorage(false);
      getData(true);
    }

    return (
      <Fragment>
        <Row className="consumption mb-4">
          {usersCard}
          {projectsCard}
          {txCard}
          {storageCard}
          {balanceCard}
          {incomeCard}
        </Row>
        {/* Modal para las opciones proyectos */}
        <UpgradePlanModal showModal={possibleSlotsToBuy==0 && addingProjects && slotsInfo.availableSlots==0} text={"In order to add a new project you need to upgrade your plan. \n You have consumed the maximun slots available."} onCloseModal={whenClosing} currentSuscription={currentSuscription}/>
      {(addingProjects && slotsInfo.availableSlots > 0 ) 
        ? <AddProjectModal 
          shown={addingProjects && slotsInfo.availableSlots > 0} 
          onSuccessCreation = {whenClosing} 
          onCloseAction={whenClosing}
          setAvailable={setAvailableAdd}/>
        : <AddProjectModalSel possibleProjectsToBuy={possibleSlotsToBuy} shown={addingProjects && possibleSlotsToBuy>0} onCloseAction={whenClosing}/> 
        
      }

{/*

      {(addingDevelopers && MaxMembers-UsedMembers > 0 ) 
        ? <AddDeveloperModal 
          shown={addingDevelopers && MaxMembers-UsedMembers > 0} 
          onSuccessCreation = {whenClosing} 
          onCloseAction={whenClosing}
          setAvailable={setAvailableAdd}/>
        : <AddDeveloperModalSel possibleProjectsToBuy={possibleSlotsToBuy} shown={addingDevelopers && possibleDevelopersToBuy>0} onCloseAction={whenClosing}/> 
        
      }

    */}
<AddDeveloperModalSel DeveloperMultiplier={DeveloperMultiplier} possibleProjectsToBuy={possibleDevelopersToBuy} shown={addingDevelopers && possibleDevelopersToBuy>0} onCloseAction={whenClosing}/> 

        {/* Modal para las opciones de Storage */}
        {addingStorage && <AddStorageModal shown={addingStorage} onCloseAction={whenClosing} onSuccess={onSuccess} MaxDBSize={MaxDBSize} ActualDBSize={ActualDBSize}/>}
        {/* Modal para las opciones de Tx */}
        {addingTx && <AddTxSelModal shown={addingTx} onCloseAction={whenClosing} onSuccess={onSuccess} maxMonthLimit={maxTX} actualMonthLimit={actualTX}/>}
        {/* Modal para las opciones de Balance */}
        {addingBalance && <AddBalanceModalSelection shown={addingBalance} onCloseAction={whenClosing} onSuccess={onSuccess}/>}
        {/* Modal para las opciones de Income */}
        {removingIncome && <AddIncomeModalSelection shown={removingIncome} onCloseAction={whenClosing} onSuccess={onSuccess}/>}
      </Fragment>
    );
};

export default Consumptions;